module.exports = __webpack_public_path__ + "img/c03_unitstartechspearmanchampion_Normal_ua.4b6716f7.webp";